package com.eladfinish.bible.contest.screens.openQuestions.api

import com.eladfinish.bible.contest.network.simplifiedApiResultUTF8
import com.eladfinish.bible.contest.screens.openQuestions.model.SheetNames
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.url

interface GoogleScriptApi {
    suspend fun getSheetNames(id: String): Result<SheetNames?>
}

class GoogleScriptApiImpl(
    private val client: HttpClient,
) : GoogleScriptApi {

    companion object {
        private const val SCRIPT_URL = "https://script.google.com/macros/s"

        // TODO: put in remote config
        private const val SCRIPT_ID = "AKfycbwIFoTlIuCo5LRlyEk4fk_GDMkgUJBY63jEXMPRRZ_5-tLD04nyxof5TWO3BH6fFz4"
    }

    override suspend fun getSheetNames(
        id: String,
    ): Result<SheetNames?> =
        simplifiedApiResultUTF8 {
            client.get {
                url(urlString = "$SCRIPT_URL/$SCRIPT_ID/exec")
                parameter("id", id)
            }
        }

}
